module.exports = __webpack_public_path__ + "assets/img/dx14.ddd4091b.png";